import {Component, Input, OnInit} from '@angular/core';
import {mobileCheck} from '../../../../../utilities';
import { GeneralInputButton } from '@tilby/tilby-ui-lib/models';
import { TilbyGeneralInputButtonComponent } from '@tilby/tilby-ui-lib/components/tilby-buttons';
import { TruncatedTextDirective } from 'src/app/directives/truncated-text.directive';

@Component({
    selector: 'app-left-context-toolbar',
    standalone:true,
    templateUrl: './left-context-toolbar.component.html',
    styleUrls: ['./left-context-toolbar.component.scss'],
    imports: [
        TilbyGeneralInputButtonComponent,
        TruncatedTextDirective
    ],
    host: {class: 'tw-flex tw-items-center'}
})
export class LeftContextToolbarComponent implements OnInit {
    isMobile = mobileCheck();
    @Input() btn?: GeneralInputButton;
    @Input() label='';
    @Input() showTitle = false;

    ngOnInit(): void {
    }
}
